import { memo } from 'react';
import classNames from 'classnames';
import './index.scss';

interface IProps {
    className?: string;
}

const EmptyData = ({ className }: IProps) => {
    return (
        <div className={classNames('equity-cards-empty-container', className)}>
            <div className="equity-cards-empty">
                <img src="http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202406/06/619d2_20240606093432.png" />
                <span>暂无记录</span>
            </div>
        </div>
    );
};

export default memo(EmptyData);
